// Single source of truth for Google Wallet header/text contrast vs background (was card_type_preview).
export function textColorFromBackground(color) {
  const hexRegExp = /#([0-9a-f]{2})([0-9a-f]{2})([0-9a-f]{2})/i
  const match = hexRegExp.exec(color)
  if (!match) return "#202124"

  const [, r, g, b] = match
  const brightness =
    (parseInt(r, 16) * 299 + parseInt(g, 16) * 587 + parseInt(b, 16) * 114) / 1000

  return brightness > 170 ? "#202124" : "#ffffff"
}
